import { useContext, useMemo } from "react";
import { AvisConstants } from "../../../../../data/avisConstants";
import { CreationNameInfo } from "../../../../../generated/data-contracts";
import { AvisSection } from "../../../../shared/components/form";
import {
  AvisSimpleTable,
  IColumnConfig,
} from "../../../../shared/components/table";
import { AvisContext } from "../../../../shared/context/AvisContext";

interface ICreationNamesProps {
  data: CreationNameInfo[] | undefined;
}

export function CreationNames(props: Readonly<ICreationNamesProps>) {
  const { res } = useContext(AvisContext);
  const { data } = props;
  const columnMetadata: IColumnConfig[] = useMemo(() => {
    return [
      {
        metadata: AvisConstants.table_default_column_metadata,
        type: "String",
        name: "creationNameName",
        translation: res("authors_Creation_Section_Names_column_NameType"),
      },
      {
        metadata: AvisConstants.table_default_column_metadata,
        type: "String",
        name: "name",
        translation: res("authors_Creation_Section_Names_column_Name"),
      },
    ];
  }, [res]);
  if (!data) return; //Do not draw section if is not defined

  return (
    <AvisSection
      collapsable
      title={res("authors_Creation_Section_Names_Title")}
      textToDisplayKey="portal_RH_CreationCard_Names"
    >
      <AvisSimpleTable<CreationNameInfo>
        columnMetadata={columnMetadata}
        data={data}
        columnWidths={[30, 70]}
      />
    </AvisSection>
  );
}
